const Profile = {
  profile__container: {
    paddingTop: '72px',
  },
  logoContainer: {
    textAlign: 'center',
  },
  name: {
    height: '29px',

    fontSize: '18px',
    fontWeight: 'bold',
    color: 'var(--grey-2)',
  },
  userName: {
    textAlign: 'right',
  },
  id: {
    fontSize: '14px',
    color: 'var(--grey-2)',
  },
  editButton: {
    cursor: 'pointer',
    width: '118px',
    padding: '5px 0',
    borderRadius: '16px',
    boxShadow: '1px 1px 2px 0 rgba(0, 0, 0, 0.16)',
    border: 'solid 1px var(--white)',
    backgroundColor: 'var(--light-gray-1)',
    textAlign: 'center',
    color: 'var(--grey-2)',
    fontSize: '14px',

    outline: 'none',
  },
  divider: {
    width: '100%',
    height: '1px',
    background: 'var(--light-gray-3)',
    margin: '16px 0',
  },
  divider2: {
    width: '100%',
    height: '1px',
    background: 'var(--light-gray-3)',
    margin: '12px 0 16px',
  },
  rightHeaders: {
    fontSize: '14px',
    color: 'var(--light-blue)',
  },
  leftHeaders: {
    fontSize: '16px',
    color: 'var(--purply)',
    textAlign: 'right',
  },

  logout: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row-reverse',
    alignItems: 'center',
    cursor: 'pointer',
    width: '90px',
    height: '45px',
    padding: '15px 0 12px 0',
    marginLeft: '-13px !important',
    borderRadius: '16px !important',
    boxShadow:
      '-10px -10px 30px #FFFFFF, 10px 10px 30px rgba(174, 174, 192, 0.4)',
    border: '1px solid #FFFFFF !important',
  },
  logoutText: {
    fontSize: '14px',
    color: 'var(--grey-2)',
    border: 'none',
    marginRight: '15px',
    textAlign: 'center',
    backgroundColor: 'transparent',
  },
  FooterText: {
    height: '14px',
    margin: '0 0 22px 0',

    fontSize: '9px',
    color: 'var(--grey-2)',
  },
  profileContainer: {
    width: '100%',
    margin: '24px 24px 0 24px ',
    backgroundColor: '#F4F4F4',
    border: '1px solid #FFFFFF',
    boxShadow:
      ' -10px -10px 30px #FFFFFF, 10px 10px 30px rgba(174, 174, 192, 0.4)',
    borderRadius: '20px',
  },
  profileHeader: {
    fontSize: '16px',
    fontFamily: 'dana-bold',
    textAlign: 'center',
    color: '#3CC0C3',
    marginTop: '24px',
  },
  editProfile: {
    position: 'absolute !important',
    right: '48px',
    marginTop: '20px !important',
    width: '32px !important',
    height: '32px !important',
    minWidth: '32px !important',
    display: 'flex !important',
    justifyContent: 'center!important',
    padding: '8px !important',
    borderRadius: '98px !important',
    border: 'solid 1px #FFFFFF !important',

    backgroundColor: '#F4F4F4 !important',
    boxShadow: '-5px -5px 10px #FFFFFF, 2px 2px 10px rgba(174, 174, 192, 0.4)',
  },
  editIcon: {
    paddingRight: '3px',
    paddingTop: '3px',
  },
  centerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  lineProfile: {
    width: '60%',
    height: '2.86px',
    margin: '14px auto',
    background: '#F9FAFB',
    boxShadow:
      '-0.2px -0.5px 1px #FFFFFF, 0.5px 0.75px 1px rgba(174, 174, 192, 0.6)',
    borderRadius: '2px',
  },
  ProfileTitle: {
    fontSize: '16px',
    fontWeight: '400',
    textAlign: 'left',
    color: '#707070',
  },
  ProfileValue: {
    fontSize: '16px',
    fontFamily: 'dana-bold',
    textAlign: 'right',
    color: '#753CBE',
  },
  addDevice: {
    fontWeight: '400 !important',
    marginBottom: '15px !important',
    fontSize: '14px !important',
    color: '#6F4D9F',
    display: 'flex ',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexDirection: 'row-reverse',
  },

  //  ***********for edit part
  ButtonStyle: {
    cursor: 'pointer',
    display: 'flex !important',
    justifyContent: 'center !important',
    alignItems: 'center !important',
    height: '45px',
    width: '90px',
    textAlign: 'center',
    margin: 'auto !important',
    marginTop: '30px !important',
    marginBottom: '21px !important',
    borderRadius: '16px !important',
    boxShadow:
      '-4px -4px 15px 0 var(--white), 4px 4px 15px 0 rgba(172, 172, 172, 0.5)',
    border: 'solid 1px #ffffff !important',
  },
  ButtonLabel: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: 'var(--grey-2)',
  },
  editContainer: {
    ['@media (min-width:600px)']: {
      // eslint-disable-line no-useless-computed-key
      maxWidth: '100% !important',
      width: '100% !important',
    },
  },
  cancelBtn: {
    fontFamily: 'dana-bold',
    fontSize: '14px !important',
    lineHeight: '22px !important',
    textAlign: 'center !important',
    color: '#979797 !important',

    marginLeft: '57px !important',
  },
  formBtnContainer: {
    margin: '45px auto 24px !important',
    padding: '0 10px',
    width: '100%',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'space-between',
  },
  support: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row-reverse',
    alignItems: 'center',
    cursor: 'pointer',
    width: '137px',
    height: '40px',
    padding: '15px 0 12px 0',
    // marginLeft: '-13px !important',
    borderRadius: '16px !important',
    boxShadow: '1px 1px 2px 0px #00000029',

    border: '1px solid #FFFFFF !important',
  },
  supportText: {
    fontSize: '12px',
    color: '#6F4D9F',
    border: 'none',
    paddingLeft: '5px',
    textAlign: 'center',
    backgroundColor: 'transparent',
  },
  exitContainer: {
    display: 'flex !important',
    justifyContent: 'right !important',
    alignItems: 'center !important',
    margin: '24px 0 !important',
    padding: '0 24px 40px !important',
  },
};
export default Profile;
